/**
 * Shadows
 * Figma: https://www.figma.com/file/36q2en2Fb6AAepdm1I6NGn/Design-system?node-id=62%3A19489
 */

// these definitions are structured this way to make it easier to see multiple box shadow rules

export type Elevation = {
  boxShadow: string;
};

export const shadows = {
  subtle: [
    '0px 1px 1px rgba(0,0,0,0.06)',
    '0px 0px 2px rgba(0,0,0,0.06)',
    '0px 0px 1px rgba(0,0,0,0.08)',
  ],
  small: [
    '0px 4px 8px rgba(0,0,0,0.04)',
    '0px 0px 2px rgba(0,0,0,0.06)',
    '0px 0px 1px rgba(0,0,0,0.12)',
  ],
  medium: [
    '0px 10px 20px rgba(0,0,0,0.04)',
    '0px 2px 6px rgba(0,0,0,0.04)',
    '0px 0px 1px rgba(0,0,0,0.16)',
  ],
  mediumTop: [
    '0px 0px 1px rgba(0,0,0,0.04)',
    '0px -2px 6px rgba(0,0,0,0.04)',
    '0px -10px 20px rgba(0,0,0,0.04)',
  ],
  large: [
    '0px 16px 24px rgba(0,0,0,0.06)',
    '0px 2px 6px rgba(0,0,0,0.04)',
    '0px 0px 1px rgba(0,0,0,0.2)',
  ],
  extraLarge: [
    '0px 24px 32px rgba(0,0,0,0.04)',
    '0px 16px 24px rgba(0,0,0,0.04)',
    '0px 4px 8px rgba(0,0,0,0.04)',
    '0px 0px 1px rgba(0,0,0,0.2)',
  ],
  button: [
    '0px 1px 2px rgba(0,0,0,0.25)',
    'inset 0px 1px 0px rgba(255,255,255,0.35)',
    'inset 0px -1px 0px rgba(0,0,0,0.1)',
  ],
  buttonPress: ['inset 0px 1px 2px rgba(0,0,0,.12)'],
  inset: ['inset 0px 3px 8px rgba(0,0,0,.06)'],
  darkOverlay: [
    'inset 0px 0px 0px 0.5px rgba(0, 0, 0, 0.8)',
    'inset 0px 0px 0px 1px rgba(255, 255, 255, 0.4)',
    '0px 8px 24px 0px rgba(0, 0, 0, 0.2)',
    '0px 2px 8px 0px rgba(0, 0, 0, 0.08)',
  ],
};

export const subtleShadow = {
  boxShadow: shadows.subtle.join(', '),
};

export const smallShadow = {
  boxShadow: shadows.small.join(', '),
};

export const mediumShadow = {
  boxShadow: shadows.medium.join(', '),
};

export const mediumTopShadow = {
  boxShadow: shadows.mediumTop.join(', '),
};

export const largeShadow = {
  boxShadow: shadows.large.join(', '),
};

export const extraLargeShadow = {
  boxShadow: shadows.extraLarge.join(', '),
};

export const buttonShadow = {
  boxShadow: shadows.button.join(', '),
};

export const buttonPressShadow = {
  boxShadow: shadows.buttonPress.join(', '),
};

export const insetShadow = {
  boxShadow: shadows.inset.join(', '),
};

export const darkOverlayShadow = {
  boxShadow: shadows.darkOverlay.join(', '),
};
